import { config } from '@/entities/api/axios';
export const getImageLink = (id: string) => {
  return `${config.apiBaseUrl}api/other/FileContent/${id}`;
};
